import { uuid } from '#/utils/functional/string/uuid';

import type { ApiImageData } from './types';

const makeMockHandle = (): string => `mock_${uuid()}${uuid()}`.slice(0, 20);

export const getMockImage = (): ApiImageData => {
  const useSVG = Boolean(localStorage.getItem('filestackMockSVG'));
  const filename = useSVG ? 'image.svg' : 'image.jpg';
  const mimetype = useSVG ? 'image/svg+xml' : 'image/jpeg';
  const handle =
    localStorage.getItem('filestackNextUploadHandle') ?? makeMockHandle();

  return {
    filename,
    handle,
    mimetype,
    size: 409609,
    source: 'local_file_system',
  };
};
